import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { calculateTimeIntervalType } from 'src/components/oneCorp/features/MealCredit/utils/calculateTimeIntervalType';
import { Meridian } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface TimeIntervalTypeAutoUpdateParams {
  timeIntervalType: TimeIntervalTypeValues;
  startTime: string;
  startTimeMeridian: Meridian;
  endTime: string;
  endTimeMeridian: Meridian;
  hasStartTimeError: boolean;
  hasEndTimeError: boolean;
}

export function shouldEnableTimeIntervalTypeAutoUpdate({
  hasStartTimeError,
  hasEndTimeError,
}: TimeIntervalTypeAutoUpdateParams): boolean {
  return !hasStartTimeError && !hasEndTimeError;
}

export function calculateTimeIntervalTypeUpdate(
  params: TimeIntervalTypeAutoUpdateParams
): TimeIntervalTypeValues | null {
  if (!shouldEnableTimeIntervalTypeAutoUpdate(params)) {
    return null;
  }
  const calculatedType = calculateTimeIntervalType(params);
  if (params.timeIntervalType === calculatedType) {
    return null;
  }
  return calculatedType;
}
